export const createAddonsData = (addons = []) => addons.map(({
  otdpItemId,
  description,
  price,
  brand,
  isMandatory
}) => ({
  brand,
  name: otdpItemId,
  value: otdpItemId,
  label: description,
  price,
  isMandatory
}))

export const getInitialValues = (addons = []) => addons
  .filter(({ isMandatory, isSelected }) => isMandatory || isSelected)
  .map(({ otdpItemId }) => otdpItemId)

export const getMandatoryValues = (addons = []) => addons
  .filter(({ isMandatory }) => isMandatory)
  .map(({ otdpItemId }) => otdpItemId)

export const isTPMSItem = ({ brand }) => brand === 'TPMS'

export const isTPPItem = ({ brand }) => brand === 'TPP'
